import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    coverImageContainer: {
        aspectRatio: 0.8,
        width: "100%"
    },
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center"
    },
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    headerButton: {
        alignSelf: "flex-start"
    },
    modalOverlay: {
        justifyContent: "center",
        flex: 1
    },
    closeButton: {
        position: "absolute",
        zIndex: 20
    },
    shareButton: {
        alignSelf: "flex-end"
    },
    coverImage: {
        resizeMode: "cover",
        aspectRatio: 0.8,
        width: "100%"
    },
    container: {
        flex: 1
    }
});
export default stylesheet;
